export default __webpack_public_path__ + "static/media/carpet.abaf500d.png";